import { withResponsive } from '../../utils/hooks'
import { Container } from '../atoms'

export const ContainerResponsive = withResponsive(Container)
